<template>
  <div>
    <SellHeader :img_header="header_image" header="คำสั่งซื้อ" :link_back="link_back"/>
    <Confirm_partner_edit/>
  </div>
</template>

<script>
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/boxes_sell.png";
import Confirm_partner_edit from "@/components/admin/sell/Confirm_partner_edit";
export default {
  name: "ConfirmPartnerEdit",
  components: {
    Confirm_partner_edit,
    SellHeader
  },
  data() {
    return {
      header_image: HeaderImage,
      link_back: 'sell/orderpartnerdetail/' + this.$route.params.id
    }
  }
}
</script>

<style scoped>

</style>
